export class ModuleTopmostTabbs {
    // staff
    module;

    constructor() {
        this.init();
    }

    // fn's
    init() {

        let nav = $("#topmost-navigation-tabbed");
        let $tabs = nav.find('.navigation-tabs__item');
        let index = Math.max(0, $tabs.index($tabs.filter('.navigation-tabs__item.active')));

        $tabs
            .on('click', function (e) {
                if ($(this).hasClass( "active" )) {
                    return;
                }

                e.preventDefault();
                index = $tabs.index(this);

                $tabs
                    .removeClass('active')
                    .eq(index).addClass('active');

                let paneId = 'div#' + $(this).find('a').attr('id');
                if ($(paneId).length) {
                    togglePanes($(paneId));
                }
            });

        // auxiliary
        function togglePanes($pane) {
            if (!$pane.is('.navigation-tabs__pane.active')) {
                $pane
                    .addClass('active')
                    .siblings('[id^="navigation-tabs__pane"]').removeClass('active');
            }
        }
    }
}
